/* eslint-disable import/prefer-default-export */

import {createAction} from 'redux-actions';

export const initAccount = createAction('ACCOUNT_INIT');
